import { Controller } from "@hotwired/stimulus";

// Mirrors a range slider's current value into an output element so the member
// sees the number they are selecting.
export default class extends Controller {
  static targets = ["input", "output"];

  connect() {
    this.update();
  }

  update() {
    this.outputTarget.textContent = this.inputTarget.value;
  }
}
